import { LazyImport, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ReadWriteRecipientWell" */ './lazyIndex')
);

export let lazyFindReadWriteRecipient = new LazyAction(lazyModule, m => m.findReadWriteRecipient);
export { default as oneRecipientSelectedAction } from './actions/oneRecipientSelectedAction';
export const lazyGetGroupInfo = new LazyImport(lazyModule, m => m.getGroupInfo);
